module.exports = __webpack_public_path__ + "static/media/darktrace.042a0b5f.png";